module.exports = __webpack_public_path__ + "static/media/socials-youtube-gray.a319de05.svg";